import { useQuery } from 'query';
import { loadDataTable } from 'scenes/PerformancePage/sources/loadDataTable';

import { grid } from './queryKeyFactory';

export const useDataTable = (params: any) => {
  return useQuery(grid(params), async () => {
    return loadDataTable(params);
  });
};
